// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__3PSb2","col":"CardReaderDesc_col__2GSbe","label":"CardReaderDesc_label__18S9m"};